import React from "react";
import "./comments.css";
import {
  Button,
  InputGroup,
  Typography,
} from "@anchor/react-components/dist/lib/components";

import { DragDropContext, Droppable, e } from "react-beautiful-dnd";
import { MdOutlineDone } from "react-icons/md";
import { SiCodereview } from "react-icons/si";

import { HandleComments } from ".";
import CommentSection from "./CommentSection";
import { BiTask } from "react-icons/bi";

function Comments({
  contextState,
  dispatch,
  commentsData,
  contextField,
  postmortemCurrentStatus,
}) {
  const {
    handleCommentChange,
    handleAddComments,
    handleDeleteComment,
    handleEditComment,
    comment,
    comments,
    graphData,
    userIsAdmin,
    handleDragAndDrop,
  } = HandleComments(
    postmortemCurrentStatus,
    dispatch,
    contextState,
    contextField,
    commentsData
  );

  return (
    <DragDropContext onDragEnd={handleDragAndDrop}>
      <div className="seventh-step">
        <Typography
          variant="h2"
          fontStyle="bold"
          style={{ fontSize: "20px", textAlign: "center" }}
        >
          FeedBack Comments
        </Typography>

        <InputGroup
          appendGroup={
            <div>
              <Button
                style={{ background: "none", border: "none" }}
                disabled={!comment}
                appearance="inverse"
                className="search"
                icon="plus"
                id="primary"
                justifyItems="center"
                onClick={handleAddComments}
                // label="Add Owner"
                name="primary"
                title=""
                type="button"
                variant="filled"
              />
            </div>
          }
          fit="medium"
          inputProps={{
            id: "textInput",
            onChange: handleCommentChange,
            placeholder: "Please enter your comment",
            type: "text",
            value: comment,
          }}
          variant="vanity"
        />
        <div style={{ display: "flex" }}>
          <Droppable type="group" droppableId="NEW">
            {(provided) => (
              <div
                {...provided.droppableProps}
                ref={provided.innerRef}
                className={
                  userIsAdmin
                    ? "comments-wrapper"
                    : "comments-wrapper-non-admin"
                }
              >
                <CommentSection
                  provided={provided}
                  sectionHeading="New"
                  commentSection="NEW"
                  comments={comments}
                  graphData={graphData}
                  handleEditComment={handleEditComment}
                  handleDeleteComment={handleDeleteComment}
                  sectionPic={
                    <BiTask
                      style={{
                        fontSize: "60px",
                        color: "#CFCFCF",
                        fontWeight: "100",
                      }}
                    />
                  }
                />
              </div>
            )}
          </Droppable>

          <Droppable type="group" droppableId="INREVIEW">
            {(provided) => (
              <div
                {...provided.droppableProps}
                ref={provided.innerRef}
                className={
                  userIsAdmin
                    ? "comments-wrapper"
                    : "comments-wrapper-non-admin"
                }
              >
                <CommentSection
                  provided={provided}
                  sectionHeading="Review"
                  commentSection="INREVIEW"
                  comments={comments}
                  graphData={graphData}
                  handleEditComment={handleEditComment}
                  handleDeleteComment={handleDeleteComment}
                  sectionPic={
                    <SiCodereview
                      style={{
                        fontSize: "60px",
                        color: "#CFCFCF",
                        fontWeight: "100",
                      }}
                    />
                  }
                />
              </div>
            )}
          </Droppable>

          {userIsAdmin && (
            <Droppable type="group" droppableId="DONE">
              {(provided) => (
                <div
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  className="comments-wrapper"
                >
                  <CommentSection
                    provided={provided}
                    sectionHeading="Done"
                    commentSection="DONE"
                    comments={comments}
                    graphData={graphData}
                    handleEditComment={handleEditComment}
                    handleDeleteComment={handleDeleteComment}
                    sectionPic={
                      <MdOutlineDone
                        style={{ fontSize: "60px", color: "#CFCFCF" }}
                      />
                    }
                  />
                </div>
              )}
            </Droppable>
          )}
        </div>
      </div>
    </DragDropContext>
  );
}

export default Comments;
